import { Lock, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// Gate for PRIVATE areas (health history, Diabetes Centre). Not a paywall —
// accounts are free; sign-in is required because these pages hold sensitive
// personal health data that must belong to an authenticated account.
export default function RequireAuth({ children, title = "This area is private" }) {
  const { user, loading, openAuth } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#05050A] flex items-center justify-center">
        <Loader2 className="w-6 h-6 text-cyan-400 animate-spin" />
      </div>
    );
  }
  if (!user) {
    return (
      <div
        data-testid="require-auth-screen"
        className="min-h-screen bg-[#05050A] text-white flex items-center justify-center px-6"
      >
        <div className="max-w-md w-full rounded-3xl border border-white/10 bg-white/[0.03] p-8 text-center">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-gradient-to-br from-[#0B3D91] to-cyan-500 flex items-center justify-center shadow-[0_0_30px_rgba(0,229,255,0.3)]">
            <Lock className="w-7 h-7 text-white" />
          </div>
          <h1 className="mt-5 font-display text-2xl font-semibold">{title}</h1>
          <p className="mt-2 text-sm text-zinc-400 leading-relaxed">
            Your health history is stored securely under your free account so
            that only you can ever see it — on this device or any other.
          </p>
          <button
            data-testid="require-auth-signin-btn"
            onClick={openAuth}
            className="mt-6 w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full btn-glow text-white text-sm font-medium"
          >
            <LogIn className="w-4 h-4" />
            Sign in / Create free account
          </button>
        </div>
      </div>
    );
  }
  return children;
}
